import dayjs from "dayjs";
import { Tooltip } from "antd";

export const tabData = [
	{ label: "Advocates", content: "LAWYERS", key: "1" },
	{ label: "Customers", content: "CUSTOMERS", key: "2" }
];

export const actionDropdownMenu = [
	{ key: "view", label: "View" },
	{ key: "complete", label: "Resolve Issue" },
	{ key: "refund", label: "Refund" },
];

export const complaintStatusOptions = [
	{ key: "PENDING", value: "PENDING", label: "PENDING" },
	{ key: "COMPLETED", value: "COMPLETED", label: "COMPLETED" },
];

export const refundPercentageOptions = [
	{ key: "25%", value: "25%", label: "25%" },
	{ key: "50%", value: "50%", label: "50%" },
	{ key: "75%", value: "75%", label: "75%" },
	{ key: "100%", value: "100%", label: "100%" },
];

export const recordStatusOptions = [
	{ key: "RECORDED", value: "RECORDED", label: "Recorded" },
	{ key: "NOT_RECORDED", value: "NOT_RECORDED", label: "Not Recorded" }
];

export const isRecordMarkedAsRecorded = (recordValue) => {
	if (recordValue === true) return true;
	if (recordValue === false || recordValue === null || recordValue === undefined) return false;
	const normalizedRecordValue = String(recordValue).trim().toUpperCase();
	return normalizedRecordValue === "RECORDED" || normalizedRecordValue === "TRUE";
};

export const checkIsConsultationRecorded = (...sources) => {
	for (const src of sources) {
		if (!src) continue;
		if (isRecordMarkedAsRecorded(src?.record) || isRecordMarkedAsRecorded(src?.isRecord)) {
			return true;
		}
		const candidates = [
			src?.consultationDetails,
			src?.consultationInfo,
			src?.consultationPaymentDetails,
			src?.consultationDetails?.consultationPaymentDetails,
			src?.consultationDetails?.recordDetail,
			src?.consultationDetails?.consultationPaymentDetails?.recordDetail,
			src?.consultationPaymentDetails?.recordDetail,
			src?.recordDetail
		];
		for (const item of candidates) {
			if (item) {
				if (
					isRecordMarkedAsRecorded(item?.record) ||
					isRecordMarkedAsRecorded(item?.isRecord) ||
					Boolean(item?.recordingUrl)
				) {
					return true;
				}
			}
		}
	}
	return false;
};

export const LAWYERS_COLUMNS = ({ actionRender, complaintStatusOptions }) => [
	{
		title: "SNo",
		width: 60,
		align: "center",
		render: (_, detail, index) => <>{index + 1}</>
	},
	{
		title: "Date",
		width: 100,
		align: "center",
		render: (detail) => detail?.complaintDate ? dayjs(detail?.complaintDate).format("DD-MM-YYYY") : "Nil"
	},
	{
		title: "Cons. Date",
		width: 130,
		align: "center",
		render: (detail) => detail?.consultationDate ? dayjs(detail?.consultationDate).format("DD-MM-YYYY") : "Nil"
	},
	{
		title: "Cons. ID",
		width: 130,
		align: "center",
		dataIndex: "consultationNo",
		render: (consultationNo) => (
			<span>{consultationNo?.length > 15 ? `${consultationNo?.slice(0, 12)}...` : consultationNo || "Nil"}</span>
		)
	},
	{
		title: "Complaint ID",
		dataIndex: "complaintNo",
		width: 120,
		render: (complaintNo) => complaintNo || "Nil"
	},
	{
		title: "Customer & ID",
		width: 130,
		align: "center",
		render: (detail) => {
			const name = detail?.raisedByName || "Nil";
			const id = detail?.raisedByNo || "Nil";
			return (
				<div>
					<span style={{ fontWeight: '600' }}>{name?.length > 15 ? `${name?.slice(0, 12)}...` : name || "Nil"}</span>
					{id && <br />}
					{id && <small>{id}</small>}
				</div>
			);
		}
	},
	{
		title: "Advocate & ID",
		width: 130,
		align: "center",
		render: (detail) => {
			const name = detail?.againstByName || "Nil";
			const id = detail?.againstByNo || "Nil";
			return (
				<div>
					<span style={{ fontWeight: '600' }}>{name?.length > 15 ? `${name?.slice(0, 12)}...` : name || "Nil"}</span>
					{id && <br />}
					{id && <small>{id}</small>}
				</div>
			);
		}
	},
	{
		title: "Complaint Description",
		dataIndex: "complaintDescription",
		width: 250,
		render: (_, detail) => {
			const description = detail?.complaintDescription || "Nil";
			if (description?.length > 25) {
				return <Tooltip title={description}>
					<span>{description?.slice(0, 25)}...</span>
				</Tooltip>
			}
			return <><span>{description}</span></>
		}
	},
	{
		title: "Advocate Reply",
		dataIndex: "lawyerReplayToComplaint",
		width: 250,
		render: (_, detail) => {
			const description = detail?.lawyerReplayToComplaint || "Nil";
			if (description?.length > 25) {
				return <Tooltip title={description}>
					<span>{description?.slice(0, 25)}...</span>
				</Tooltip>
			}
			return <><span>{description}</span></>
		}
	},
	...(complaintStatusOptions === "COMPLETED" ? [
		{
			title: "Action Taken",
			width: 250,
			render: (detail) => {
				const action = detail?.actionItemRaisedBy ?? detail?.actionItemAgainstBy;
				if (action?.length > 25) {
					return <Tooltip title={action}>
						<span>{action?.slice(0, 25)}...</span>
					</Tooltip>
				}
				return <><span>{action}</span></>
			}
		},
		{
			title: "Action Type",
			width: 150,
			render: (detail) => {
				return <>{detail?.complaintActionType || "Nil"}</>
			}
		},
		{
			title: "Warned By",
			width: 120,
			dataIndex: "warnedByName",
			render: (warnedByName) => warnedByName || "Nil"
		}
	] : []),
	{
		title: "Record",
		width: 180,
		render: (detail) => {
			const hasRecordedStatus = isRecordMarkedAsRecorded(detail?.record);
			return <>
				{
					hasRecordedStatus ? <div className="success-status">
						<p className="custom-header">Recorded</p>
					</div> : <div className="danger-status">
						<p className="custom-header">Not Recorded</p>
					</div>
				}
			</>
		}
	},
	{
		title: "Complaint",
		width: 180,
		render: (detail) => {
			return <>
				{
					detail?.complaintStatus === "COMPLETED" ? <div className="success-status">
						<p className="custom-header">Completed</p>
					</div> : detail?.complaintStatus === "PENDING" ? <div className="pending-status">
						<p className="custom-header">Pending</p>
					</div> : <div style={{ textAlign: "center" }}>-</div>
				}
			</>
		}
	},
	{
		title: "Action",
		width: 80,
		fixed: "right",
		align: "center",
		render: (list) => actionRender(list)
	}
];

export const CUSTOMERS_COLUMNS = ({ actionRender, complaintStatusOptions }) => [
	{
		title: "SNo",
		width: 60,
		align: "center",
		render: (_, detail, index) => <>{index + 1}</>
	},
	{
		title: "Date",
		width: 100,
		align: "center",
		render: (detail) => detail?.complaintDate ? dayjs(detail?.complaintDate).format("DD-MM-YYYY") : "Nil"
	},
	{
		title: "Cons. Date",
		width: 130,
		align: "center",
		render: (detail) => detail?.consultationDate ? dayjs(detail?.consultationDate).format("DD-MM-YYYY") : "Nil"
	},
	{
		title: "Cons. ID",
		width: 130,
		align: "center",
		dataIndex: "consultationNo",
		render: (consultationId) => (
			<span>{consultationId?.length > 15 ? `${consultationId?.slice(0, 12)}...` : consultationId || "Nil"}</span>
		)
	},
	{
		title: "Complaint ID",
		dataIndex: "complaintNo",
		width: 120,
		render: (complaintNo) => complaintNo || "Nil"
	},
	{
		title: "Advocate & ID",
		width: 130,
		align: "center",
		render: (detail) => {
			const name = detail?.raisedByName || "Nil";
			const id = detail?.raisedByNo || "Nil";
			return (
				<div>
					<span style={{ fontWeight: '600' }}>{name?.length > 15 ? `${name?.slice(0, 12)}...` : name}</span>
					{id && <br />}
					{id && <small>{id}</small>}
				</div>
			);
		}
	},
	{
		title: "Customer & ID",
		width: 130,
		align: "center",
		render: (detail) => {
			const name = detail?.againstByName || "Nil";
			const id = detail?.againstByNo || "Nil";
			return (
				<div>
					<span style={{ fontWeight: '600' }}>{name?.length > 15 ? `${name?.slice(0, 12)}...` : name || "Nil"}</span>
					{id && <br />}
					{id && <small>{id}</small>}
				</div>
			);
		}
	},
	{
		title: "Complaint Description",
		dataIndex: "complaintDescription",
		width: 250,
		render: (_, detail) => {
			const description = detail?.complaintDescription || "Nil";
			if (description?.length > 25) {
				return <Tooltip title={description}>
					<span>{description?.slice(0, 25)}...</span>
				</Tooltip>
			}
			return <><span>{description}</span></>
		}
	},
	...(complaintStatusOptions === "COMPLETED" ? [
		{
			title: "Action Taken",
			width: 250,
			render: (detail) => {
				const action = detail?.actionItemRaisedBy ?? detail?.actionItemAgainstBy;
				if (!action) return "Nil";
				if (action?.length > 25) {
					return <Tooltip title={action}>
						<span>{action?.slice(0, 25)}...</span>
					</Tooltip>
				}
				return <><span>{action}</span></>
			}
		},
		{
			title: "Action Type",
			width: 150,
			render: (detail) => {
				return <>{detail?.complaintActionType || "Nil"}</>
			}
		},
		{
			title: "Warned By",
			width: 120,
			dataIndex: "warnedByName",
			render: (warnedByName) => warnedByName || "Nil"
		}
	] : []),
	{
		title: "Record",
		width: 180,
		render: (detail) => {
			const hasRecordedStatus = isRecordMarkedAsRecorded(detail?.record);
			return <>
				{
					hasRecordedStatus ? <div className="success-status">
						<p className="custom-header">Recorded</p>
					</div> : <div className="danger-status">
						<p className="custom-header">Not Recorded</p>
					</div>
				}
			</>
		}
	},
	{
		title: "Complaint",
		width: 180,
		render: (detail) => {
			return <>
				{
					detail?.complaintStatus === "COMPLETED" ? <div className="success-status">
						<p className="custom-header">Completed</p>
					</div> : detail?.complaintStatus === "PENDING" ? <div className="pending-status">
						<p className="custom-header">Pending</p>
					</div> : <div style={{ textAlign: "center" }}>-</div>
				}
			</>
		}
	},
	{
		title: "Action",
		width: 80,
		fixed: "right",
		align: "center",
		render: (list) => actionRender(list)
	},
];

export const filterStatusOptions = [
	{ key: "ALL", value: "ALL", label: "All" },
	{ key: "PENDING", value: "PENDING", label: "Pending" },
	{ key: "RESOLVED", value: "RESOLVED", label: "Resolved" },
	{ key: "CLOSED", value: "CLOSED", label: "Closed" }
];

export const messageTabData = [
	{ key: "1", label: "Raised By", content: "raised" },
	{ key: "2", label: "Against By", content: "against" }
];

export const handleMessageTabChange = (key, setMessageData) => {
	const selectedTab = messageTabData.find((tab) => tab.key === key);
	if (selectedTab) {
		setMessageData((prev) => ({
			...prev,
			activeTab: selectedTab.content,
			activeTabKey: key,
			body: "",
			subject: "",
			isWhatsapp: false,
			isMail: true,
		}));
	}
};
